var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 163,
    viewBox: "0 0 164 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0417 122.25V115.458C48.0417 96.7038 63.2454 81.5 82.0001 81.5C100.755 81.5 115.958 96.7038 115.958 115.458V122.25",
    stroke: "#21272A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82 81.5C93.2531 81.5 102.375 72.3781 102.375 61.125C102.375 49.8722 93.2531 40.75 82 40.75C70.7469 40.75 61.625 49.8722 61.625 61.125C61.625 72.3781 70.7469 81.5 82 81.5Z",
    stroke: "#21272A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9999 149.417C119.509 149.417 149.917 119.009 149.917 81.5C149.917 43.9907 119.509 13.5834 81.9999 13.5834C44.4906 13.5834 14.0833 43.9907 14.0833 81.5C14.0833 119.009 44.4906 149.417 81.9999 149.417Z",
    stroke: "#21272A",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.391974352cfcbbb61f553254b203034b.svg";
export { ForwardRef as ReactComponent };